export default __webpack_public_path__ + "static/media/icon-doctor-motif.4019611a.svg";